import {
  FETCH_GUIDANCE,
  FETCH_GUIDANCE_SUCCESS,
  FETCH_GUIDANCE_FAILED,
} from "../actions/actionTypes";

const initialState = {
  isLoading: true,
  content: {},
  error: false,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_GUIDANCE:
      return {
        ...state,
        isLoading: true,
        content: {},
        mem: {},
      };
    case FETCH_GUIDANCE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        content: payload,
        mem: payload.mem,
      };
    case FETCH_GUIDANCE_FAILED:
      return {
        ...state,
        isLoading: false,
        content: {},
        mem: {},
        error: payload,
      };
    default:
      return state;
  }
}
